<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">Cliente</h1>
      <div class="title-main">
        <p>Atualmente, temos acesso a tanta informação - por vontade própria ou não - que se faz necessário um grande esforço das marcas para captar nossa atenção. Na maioria das vezes, marcas que se destacam no gosto de seu público são as que oferecem as melhores experiências para seus consumidores. Este movimento em prol da experiência se tornou tão forte que podemos colocá-lo como um dos objetivos finais da Transformação Digital.</p>
        <p>E a sua empresa? Utiliza seus recursos humanos e tecnológicos para buscar melhoria na experiência do consumidor?</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import rollDown from './mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'customer',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/cliente/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 4);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Customer.vue